import { render, staticRenderFns } from "./wisata.vue?vue&type=template&id=6edece60&"
import script from "./wisata.vue?vue&type=script&lang=js&"
export * from "./wisata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports